// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { PaymentProfilesContext } from "@insite/content-library/Pages/SavedPaymentsPage";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconProps } from "@insite/mobius/Icon";
import CreditCard from "@insite/mobius/Icons/CreditCard";
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import { typographyGetNoResultsAltProps } from "@store/Themes/common/props/typography";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins/spacing";
/* Starter Custom Code - End */

type Props = WidgetProps;

export interface SavedPaymentsViewStyles {
    centeringWrapper?: InjectableCss;
    loadingSpinner?: LoadingSpinnerProps;
    noPaymentsWrapper?: InjectableCss;
    noPaymentsIconWrapper?: InjectableCss;
    noPaymentsIcon?: IconProps;
    noPaymentsText?: TypographyProps;
    headerContainer?: GridContainerProps;
    headerLeftColumnGridItem?: GridItemProps;
    headerRightColumnGridItem?: GridItemProps;
    mainContainer?: GridContainerProps;
    mainLeftColumnGridItem?: GridItemProps;
    mainRightColumnGridItem?: GridItemProps;
    // Starter Custom Code
    loadingOverlay?: LoadingOverlayProps;
}

export const viewStyles: SavedPaymentsViewStyles = {
    noPaymentsWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            height: ${pxToRem(150)};
            justify-content: center;
            align-items: center;
        `,
    },
    noPaymentsIcon: {
        src: CreditCard,
        color: "primary",
        size: 42,
        css: spacingStyles(null, pxToRem(5)),
    },
    noPaymentsText: typographyGetNoResultsAltProps(),
};

const styles = viewStyles;

const SavedPaymentsView: React.FC<Props> = ({ id }) => {
    const paymentProfilesDataView = usePersistentDataView(useContext(PaymentProfilesContext)); // Starter Custom Code

    const isLoaded = paymentProfilesDataView.value && !paymentProfilesDataView.isLoading;
    const hasSavedPayments = isLoaded && paymentProfilesDataView.value!.length > 0;

    return (
        /* Starter Custom Code - Start */
        <DataViewLoadingOverlay dataView={paymentProfilesDataView} {...styles.loadingOverlay}>
            {!paymentProfilesDataView.value?.length && !paymentProfilesDataView.isLoading ? (
                <>
                    <StyledWrapper {...styles.noPaymentsWrapper}>
                        <Icon {...styles.noPaymentsIcon} />
                        <Typography {...styles.noPaymentsText} data-test-selector="noPaymentsMessage">
                            {siteMessage("SavedPayments_NoSavedPaymentsMessage")}
                        </Typography>
                    </StyledWrapper>
                </>
            ) : (
                <Zone contentId={id} zoneName="Content2" />
            )}
        </DataViewLoadingOverlay>
        /* Starter Custom Code - End */
    );
};

const widgetModule: WidgetModule = {
    component: SavedPaymentsView,
    definition: {
        displayName: "View",
        group: "Saved Payments",
        allowedContexts: ["SavedPaymentsPage"],
    },
};

export default widgetModule;
